import * as React from "react";
import { TabsContainer, TabConfig } from "app/ui/tabs/tab";
import { TabAttributes } from "app/ui/tabs/tab.attributes";
import { TabInfo } from "app/ui/tabs/tab.info";
import { TabInstances } from "app/ui/tabs/tab.instances";
import { TabRelations } from "app/ui/tabs/tab.relations";
import { TabSpecifications } from "app/ui/tabs/tab.specifications";
import { TabOverview } from "app/ui/tabs/tab.overview";
import { ITerm, Term } from "app/services/data-model";
import { StartPage } from "./start-page";

export function InformationPane({ config, currentTerm }: { config: any; currentTerm?: ITerm }) {
    if (!currentTerm || !currentTerm.iri) {
        return <section>{config.startPage && <StartPage config={config} />}</section>;
    }

    const tabConfigs: TabConfig[] = config.tabs.map((tab: any) => ({
        id: tab.id,
        name: tab.name,
        icon: tab.icon,
        type: tab.type
    }));

    const tabContents = config.tabs.map((tab: any) => {
        const props = { config: tab, currentUri: currentTerm.iri };
        switch (tab.type) {
            case "info":
                return <TabInfo key={tab.id} {...props} />;
            case "attributes":
                return <TabAttributes key={tab.id} {...props} />;
            case "relations":
                return <TabRelations key={tab.id} {...props} />;
            case "instances":
                return <TabInstances key={tab.id} {...props} />;
            case "specifications":
                return <TabSpecifications key={tab.id} {...props} />;
            case "overview":
                return <TabOverview key={tab.id} {...props} />;
            default:
                return null;
        }
    });

    return (
        <section>
            <h3 className="mr-auto">{currentTerm.name || Term.getLocalname(currentTerm.iri)}</h3>
            <TabsContainer tabs={tabConfigs}>{tabContents}</TabsContainer>
        </section>
    );
}
